import React from 'react';
import { useIntl } from 'react-intl';
import { Card, CardBody } from 'reactstrap';

import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import Heading from 'src/enosikit/components/Heading';

/**
 * Loading skeleton for the Trade Rule Active page.
 * Mirrors the layout of `TradeRuleActive/index.jsx`: breadcrumbs, heading,
 * and a series of trade rule card sections.
 * @returns {React.ReactElement} Placeholder component.
 */
function Placeholder() {
  const intl = useIntl();

  const propertiesBreadcrumb = intl.formatMessage({
    id: 'trade_rule.trade_rule_active.placeholder.breadcrumbs.properties',
    defaultMessage: 'Properties',
  });
  const tradeRulesBreadcrumb = intl.formatMessage({
    id: 'trade_rule.trade_rule_active.placeholder.breadcrumbs.trade_rules',
    defaultMessage: 'Trade Rules',
  });
  const tradeRulesContext = intl.formatMessage({
    id: 'trade_rule.trade_rule_active.placeholder.heading.trade_rules',
    defaultMessage: 'Trade Rules',
  });

  return (
    <div aria-hidden="true" inert>
      <Breadcrumbs
        breadcrumbs={[
          { name: propertiesBreadcrumb, path: '/properties' },
          { name: <span className="placeholder placeholder-glow bg-darken" style={{ width: '10rem' }} /> },
          { name: tradeRulesBreadcrumb },
        ]}
      />
      <Heading
        title={<span className="placeholder placeholder-glow bg-darken" style={{ width: '12rem' }} />}
        subtitle={<span className="placeholder placeholder-glow bg-darken" style={{ width: '18rem' }} />}
        context={tradeRulesContext}
      />

      {[0, 1, 2, 3, 4].map((sectionIdx) => (
        <React.Fragment key={`placeholder-section-${sectionIdx}`}>
          <Card className="mb-3">
            <CardBody>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-5" />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-7" />
              </div>
              <div>
                <span className="placeholder placeholder-glow bg-darken col-4" />
              </div>
            </CardBody>
          </Card>
        </React.Fragment>
      ))}
    </div>
  );
}

export default Placeholder;
